import Cookies from 'js-cookie'

const GCLID_PARAMS = ['gclid', 'gbraid', 'wbraid']
const COOKIE_EXPIRY_DAYS = 90
const COOKIE_NAMES = {
    gclid: 'GCG_GCLID',
    gbraid: 'GCG_GBRAID',
    wbraid: 'GCG_WBRAID',
}

/**
 * Captures Google click ID parameters (gclid, gbraid, wbraid) from the URL
 * and stores them in first-party cookies with a 90-day expiry.
 * Should be called once on app load.
 */
export const captureGclid = () => {
    const params = new URLSearchParams(window.location.search)

    GCLID_PARAMS.forEach((param) => {
        const value = params.get(param)
        if (value) {
            Cookies.set(COOKIE_NAMES[param], value, {
                expires: COOKIE_EXPIRY_DAYS,
                path: '/',
                secure: window.location.protocol === 'https:',
                sameSite: 'Lax',
            })
        }
    })
}

/**
 * Returns the stored gclid (or gbraid/wbraid fallback) from cookies.
 */
export const getStoredGclid = () => {
    return (
        Cookies.get(COOKIE_NAMES.gclid) ||
        Cookies.get(COOKIE_NAMES.gbraid) ||
        Cookies.get(COOKIE_NAMES.wbraid) ||
        null
    )
}

/**
 * Returns the specific click ID type that is stored.
 */
export const getStoredClickId = () => {
    for (const param of GCLID_PARAMS) {
        const value = Cookies.get(COOKIE_NAMES[param])
        if (value) {
            return { type: param, value }
        }
    }
    return null
}
